<template>
    <span class="l-text" data-test-id="l-text" v-html="formattedText"></span>
</template>

<script>
import formatRichText from "@/utils/format-rich-text";

export default {
    props: {
        text: {
            type: String,
            required: true,
        },
        oneLine: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        formattedText() {
            const text = String(this.text);

            if (this.oneLine) {
                const newLineIndex = text.indexOf(`\n`);
                if (newLineIndex > -1) {
                    return formatRichText(text.substring(0, newLineIndex));
                }

                return formatRichText(text);
            }
            return formatRichText(text);
        },
    },
};
</script>

<style scoped></style>
